import type {
  UUIDv7,
  AuditPlanResourceSchema,
  CreateAuditPlanInput,
  CreateAuditPlanResult,
} from "./rpc";
import * as Rpc from "./rpc";
import type { Assignment } from "./assignment";

export type AuditPlanAssignment = Pick<
  Assignment,
  | "id"
  | "name"
  | "state"
  | "type"
  | "description"
  | "completionPercentage"
  | "insertedAt"
  | "updatedAt"
>;

export type AuditPlanListItem = Pick<
  AuditPlanResourceSchema,
  "id" | "state" | "title" | "completionPercentage" | "referenceYear"
>;

export type AuditPlan = Omit<
  AuditPlanResourceSchema,
  "__type" | "__primitiveFields" | "assignments"
> & {
  assignments: AuditPlanAssignment[];
};
export type CreateAuditPlanData = Extract<
  CreateAuditPlanResult,
  { success: true }
>["data"];

export const listAuditPlans = async (): Promise<AuditPlanListItem[]> => {
  const response = await Rpc.listAuditPlans({
    fields: ["id", "state", "title", "completionPercentage", "referenceYear"],
    sort: "+referenceYear,+title",
  });

  if (response.success) {
    return response.data;
  } else {
    throw new Error("Request not successfull");
  }
};

export const createAuditPlan = async (
  data: CreateAuditPlanInput,
): Promise<CreateAuditPlanData> => {
  const response = await Rpc.createAuditPlan({ input: data });

  if (response.success) {
    return response.data;
  } else {
    console.error(response.errors);

    throw new Error("Error while creating an audit plan");
  }
};

export const deleteAuditPlanById = async (id: UUIDv7) => {
  const response = await Rpc.deleteAuditPlan({ identity: id });

  if (response.success) {
    return id;
  } else {
    throw new Error("Error while deleting audit plan");
  }
};

export const getAuditPlanById = async (id: UUIDv7) => {
  const response = await Rpc.getAuditPlan({
    input: { id },
    fields: [
      "id",
      "state",
      "title",
      "referenceYear",
      "description",
      "completionPercentage",
      "lastChangeAt",
      "lastChangeBy",
      "insertedAt",
      "updatedAt",
      {
        assignments: [
          "id",
          "name",
          "state",
          "type",
          "description",
          "completionPercentage",
          "insertedAt",
          "updatedAt",
        ],
      },
    ],
  });

  if (response.success) {
    return response.data;
  } else {
    throw Error("Error while fetching Audit Plan");
  }
};

export const deferAuditPlanById = async (id: UUIDv7) => {
  const response = await Rpc.deferAuditPlan({ identity: id });

  if (response.success) {
    return response.data;
  } else {
    throw new Error("Error while deferring an Audit Plan");
  }
};
